import { render, staticRenderFns } from "./SocialConnect.vue?vue&type=template&id=68dbb83c&scoped=true&"
import script from "./SocialConnect.vue?vue&type=script&lang=js&"
export * from "./SocialConnect.vue?vue&type=script&lang=js&"
import style0 from "./SocialConnect.vue?vue&type=style&index=0&id=68dbb83c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dbb83c",
  null
  
)

export default component.exports